import {
    ArticleService
} from '@/common/api.service.js'

export class Article {
    constructor ({
        author = null,
        body = '',
        created_at = '',
        description = '',
        id = null,
        slug = '',
        tagList = null,
        title = '',
        updated_at = ''
    } = {}) {
        this.author = author
        this.body = body
        this.created_at = created_at
        this.description = description
        this.id = id
        this.slug = slug
        this.tagList = tagList
        this.title = title
        this.updated_at = updated_at
    }
}

export function responseAdapter (response) {
    return new Article({
        ...response
    })
}

export function requestAdapter (request) {
    return request
}

export default {
    getSingle: id => new Promise((resolve, reject) => {
        ArticleService.get(id)
            .then(({
                data
            }) => {
                resolve({
                    data: responseAdapter(data),
                    id: id
                })
            }).catch(e => {
                reject(e)
            })
    }),
    getList: params => new Promise((resolve, reject) => {
        ArticleService.query(params)
            .then(({
                data,
                headers
            }) => {
                resolve({
                    data: data.map(x => responseAdapter(x)),
                    headers
                })
            }).catch(e => {
                reject(e)
            })
    }),
    create: message => new Promise((resolve, reject) => {
        ArticleService.create(requestAdapter(message))
            .then((
                data
            ) => {
                resolve(data)
            }).catch(e => {
                reject(e)
            })
    }),
    update: message => new Promise((resolve, reject) => {
        ArticleService.update(message)
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    }),
    delete: id => new Promise((resolve, reject) => {
        ArticleService.delete(id)
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    })
}
